function TaskCard({ task, tasks, setTasks, onEdit }) {

  const onDragStart = (e) => {
    e.dataTransfer.setData("taskId", task.id);
  };

  const deleteTask = () => {
    if (window.confirm("Delete task?")) {
      setTasks(tasks.filter(t => t.id !== task.id));
    }
  };

  return (
    <div
      draggable
      onDragStart={onDragStart}
      style={{
        border: "1px solid #ccc",
        padding: "10px",
        margin: "6px",
        background: "#fff"
      }}
    >
      <h4>{task.title}</h4>
      <p>Priority: {task.priority}</p>
      <p>Created: {new Date(task.createdAt).toLocaleDateString()}</p>

      <button onClick={() => onEdit(task)}>Edit</button>
      <button onClick={deleteTask}>Delete</button>
    </div>
  );
}

export default TaskCard;